import React, { useRef, useContext, useState } from 'react';
import { Container, Card, Button, Form, Alert } from 'react-bootstrap'; 
import { Link, useHistory } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
const UpdateProfile = () => {

    const emailRef = useRef();
    const passwordRef = useRef();
    const passwordConfirmRef = useRef();
    const { currentUser, updateUserEmail, updateUserPassword } = useContext(AuthContext);
    const value = useContext(AuthContext);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const history = useHistory();


    function handleSubmit (e){
         e.preventDefault();

         const promises = [];
        setLoading(true);
        setError("");
        if(passwordRef.current.value !== passwordConfirmRef.current.value){
            return setError("passwords donot match");
        }

        if(passwordRef.current.value){
            promises.push(updateUserPassword(passwordRef.current.value))
        }
       
        
        if(emailRef.current.value !== currentUser.email){
            promises.push(updateUserEmail(emailRef.current.value))
        }

        Promise.all(promises).then(()=>{
            history.push("/");
        }).catch(()=>{
            setError("failed to update account try to re-login");
        }).finally(()=>{
            setLoading(false);
        })

        console.log("update");
        
    }

    return ( 
        <>
        <Container className="d-flex align-items-center justify-content-center" style={{minHeight:"100vh"}}>
      <div className="w-100" style={{ minHeight:"400px" }}>
      {/* {currentUser.email} */}
      <Card>
          <Card.Body>
              {error && <Alert variant="danger">{error}</Alert>}
              <h4 className="text-center mb-4">Update Profile</h4>
              <Form onSubmit={handleSubmit}>
                  <Form.Group id="email">
                      <Form.Label>Email</Form.Label>
                      <Form.Control type="email" ref = {emailRef} 
                        defaultValue = {currentUser ? currentUser.email: null }
                      required/>
                  </Form.Group>
                  <Form.Group id="password">
                      <Form.Label>Password</Form.Label>
                      <Form.Control type="password" ref = {passwordRef}
                        placeholder="leave it blank to keep the same"/>
                  </Form.Group>
                  <Form.Group id="passwordConfirm">
                      <Form.Label>Password</Form.Label>
                      <Form.Control type="password" ref = {passwordConfirmRef}
                        placeholder="leave it blank to keep the same"/>
                  </Form.Group>
                  <Button className="w-100 mt-4" type="submit">Update</Button>
              </Form>        
          </Card.Body>
      </Card>
      <Link to="/">
          <div className="w-100 text-center mt-2">
              Cancel
          </div>
      </Link>
      </div>
      </Container>
          
          </>
     );
}
 
export default UpdateProfile;